'use strict';

class CustomPlanPacks {
	constructor(props = {}) {
		console.log('CustomPlanPacks::constructor(%o)', props);

		const section = document.getElementById('packs_holder');
		this.packCards = section.querySelectorAll('.pack_card');
		this.broadbandPackCards = section.querySelectorAll('.pack-box');
		this.advantages = section.querySelector('.advantages');

		// #57630-broadband-card-events
		const packsHolder = document.querySelector('#packs_holder.track-broadband-interaction');
		if (packsHolder) {
			const broadbandHeader = packsHolder.getElementsByClassName('broadband_header');
			Array.from(broadbandHeader).forEach((element) => {
				element.addEventListener('click', () => this.trackBroadbandCardInteraction(element, 'packs'));
			});
		}

		const configuratorHolder = document.querySelector('#custom_plan_configurator.track-broadband-interaction');
		if (configuratorHolder) {
			const configuratorHeader = configuratorHolder.getElementsByClassName('broadband_header');
			Array.from(configuratorHeader).forEach((element) => {
				element.addEventListener('click', () => this.trackBroadbandCardInteraction(element, 'configurator'));
			});
		}
		// end #57630-broadband-card-events

		Object.assign(this, props);

		this.pageEvents();
	}

	// #57630-broadband-card-events
	trackBroadbandCardInteraction(element, source) {
		this.subtitle = '';
		this.price = '';

		if (element.classList.contains('collapsed')) {
			if (source === 'packs') {
				// Popular plans section
				const packBox = element.closest('.pack-box');
				const getCleanText = (selector) => {
					const el = packBox.querySelector(selector);

					return el ? el.textContent.trim().replace(/\s+/g, ' ') : '-';
				};

				this.subtitle = getCleanText('.subtitle');
				this.price = getCleanText('.font-size36');
			} else if (source === 'configurator') {
				// Build your own plan section
				let subtitle = '';
				let first = true;

				const configuratorHolder = document.getElementById('custom_plan_configurator');
				Array.from(configuratorHolder.getElementsByClassName('swiper-slide-active')).forEach((slide) => {
					subtitle += slide.textContent.trim().replace(/\s+/g, ' ');

					subtitle += first ? ' + ' : '';
					first = false;
				});

				let price = configuratorHolder.querySelector('.font-size39').textContent.trim().replace(/\s+/g, ' ');

				this.subtitle = subtitle;
				this.price = price;
			}
		}

		if (this.subtitle && this.price) {
			try {
				if (typeof dataLayer !== 'undefined') {
					dataLayer.push({
						'event': 'Broadband',
						'eventAction': 'Expand',
						'eventLabel': this.subtitle + ' - ' + this.price
					});
				}
				if (typeof ga !== 'undefined') {
					ga('send', 'event', 'Broadband', 'Expand', this.subtitle + ' - ' + this.price);
				}
				if (typeof _gaq !== 'undefined') {
					_gaq.push(['_trackEvent', 'Broadband', 'Expand', this.subtitle + ' - ' + this.price]);
				}
			} catch (err) {
				console.error('Error tracking broadband card interaction: %o', err);
			}
		}
	}
	// end #57630-broadband-card-events

	getMaxPackHeight() {
		let maxPackHeight = 0;

		this.packCards.forEach(card => {
			maxPackHeight = Math.max(maxPackHeight, card.offsetHeight);
		});

		return maxPackHeight;
	}

	getMaxBroadbandPackHeight() {
		let maxBroadbandPackHeight = 0;

		this.broadbandPackCards.forEach(card => {
			maxBroadbandPackHeight = Math.max(maxBroadbandPackHeight, card.offsetHeight);
		});

		return maxBroadbandPackHeight;
	}

	updatePackCardsToMaxHeight() {
		if (this.advantages) {
			this.advantages.style.maxHeight = `${this.getMaxBroadbandPackHeight()}px`;
		}

		this.packCards.forEach(card => {
			const wrapper = card.closest('.pack_card_wrapper');
			if (wrapper) {
				wrapper.style.minHeight = `${this.getMaxPackHeight()}px`;
			}
		});
	}

	pageEvents() {
		try {
			if (window.innerWidth > 992) {
				this.updatePackCardsToMaxHeight();
				window.addEventListener('resize', () => this.updatePackCardsToMaxHeight());
			}
		} catch (e) {
			console.error(`Error initializing pack cards height adjustment: ${e.message}`);
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new CustomPlanPacks({});
	} catch (e) {
		console.error(e);
	}
});
